
export default {
    props: {
        dialog: {
            type: Boolean,
            default: false,
            required: true
        },
        id: {
            type: String
        }
    },
    emits: ['close'],
    computed: {
        titleCapture() {
            return this.id ? this.$t('dialogs.delete.one.title') : this.$t('dialogs.delete.all.title');
        },
        subtitleCapture() {
            return this.id ? this.$t('dialogs.delete.one.subtitle') : this.$t('dialogs.delete.all.subtitle');
        },
        buttonCapture() {
            return this.id ? this.$t('dialogs.delete.one.btnTitle') : this.$t('dialogs.delete.all.btnTitle');
        }
    },
    methods: {
        async deleteContact() {
            try {
                let message: string;
                if (this.id) message = await this.$store.dispatch('contacts/removeContact', { id: this.id });
                else message = await this.$store.dispatch('contacts/removeAllContacts');

                this.$store.dispatch('snackbar/showSnackbar', { message, type: 'success' });
                this.closeModal();
            } catch (error) {
                this.$store.dispatch('snackbar/showSnackbar', { message: error.message, type: 'failure' });
            }
        },
        closeModal() {
            this.$emit('close');
        }
    }
};
